import * as React from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import Slider from 'react-slick';

import { AppsList, EAppItemType } from '@components';

import { IShowcaseCarouselProps } from './types';

import * as s from './ShowcaseCarousel.scss';
// eslint-disable-next-line import/no-unassigned-import
import 'slick-carousel/slick/slick.css';

@observer
export class ShowcaseCarousel extends React.Component<IShowcaseCarouselProps> {

	state = {
		isLoaded: false,
	};

	onInit = () => {
		this.setState({
			isLoaded: true,
		});
	};

	renderSlider = (state: boolean) => (array: JSX.Element[]) => {
		const sliderClass = classNames(
			s.slider,
			this.props.className,
			{ [s.slider_loaded]: state },
		);

		return <Slider
			className={ sliderClass }
			autoplay={true}
			autoplaySpeed={4000}
			arrows={false}
			dots={false}
			slidesToShow={1}
			centerPadding={'0px'}
			centerMode
			swipeToSlide
			draggable
			variableWidth={true}
			onInit={this.onInit}
		>
			{array}
		</Slider>;
	};

	render() {
		return (
			<AppsList
				appItemClassName={s.slide}
				type={EAppItemType.LARGE}
				renderCustomAppsList={ this.renderSlider(this.state?.isLoaded) }
				apps={this.props.apps}
				responseStatus={this.props.responseStatus}
				urlRef={this.props.urlRef}
			/>
		);
	}

}
